import React, { Component } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';

import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';

import { dateTimeFilter, equalTextFilter, includeTextFilter } from '../common/arrayFilters';
import { ColumnFormatters } from './tableColumnFilterFormatters';

import { connect } from 'react-redux';
import * as filterValuesActions from '../store/userConfigs/filterValuesSlice';
import * as paginationTablesActions from '../store/userConfigs/paginationTablesSlice';
import * as sortTablesActions from '../store/userConfigs/orderTablesSlice';
import * as selectedItemsActions from '../store/userConfigs/selectedItemsSlice';

import FilterTableHeader from './filterTableHeader';

const filterDefaultValues = {
  text: '',
  datetime: null,
  select: ''
};

const filterHandlers = {
  text: includeTextFilter,
  datetime: dateTimeFilter,
  select: equalTextFilter,
  weakSelect: includeTextFilter,
};

const defaultSizePerPage = 10;

class FilterTable extends Component {
  constructor(props) {
    super(props);
    this.isSelectable = this.props.selected !== undefined &&
      this.props.onSelect !== undefined &&
      this.props.onSelectAll !== undefined;

    this.filterFuncs = [];

    this.props.columns.forEach(column => {
      if (column.filter_ === undefined) return;
      const filter = column.filter_;
      if (filter.type === undefined) return;
      const filterType = filter.type;
      if (filterDefaultValues[filterType] === undefined) return;
      const colName = column.dataField;
      const filterName = this.getFilterName(colName);
      if (filterHandlers[filterType] === undefined) return;

      if (column.defaultValue) {
        this.props.setFilterValue(this.props.objectName, filterName, column.defaultValue);
        this.props.setPagination(this.props.objectName, 1, defaultSizePerPage);
      }

      const modifier = filter.modifier;

      const fields = colName.split('.');

      const accesFunc = item => {
        let val = item;
        for (let i = 0; i < fields.length; ++i) {
          let field = fields[i];
          if (val[field] === null) return null;

          val = val[field];
        }
        return val;
      };

      let defaultValue = '';
      if (filterType === 'datetime') defaultValue = { left: '', right: '' };

      const filterFunc = data => {
        const handler = filterType === 'select' && modifier === 'select-weak-comparision' ? filterHandlers.weakSelect : filterHandlers[filterType];
        return handler(
          data,
          accesFunc,
          this.props.filterValues[this.props.objectName][filterName] || defaultValue,
        );
      };
      this.filterFuncs.push(filterFunc);
    });
  }

  getFilterName(colName) {
    return `${colName}Filter`;
  }

  createFormatterParams(filter, onChangeHandler, value) {
    let params = {
      onChange: onChangeHandler
    };
    if (filter.type === 'select') {
      if (filter.values === undefined)
        return null;
      params['filterValues'] = filter.values;
    }
    params.value = value;
    return params;
  }

  createFormatter(column) {
    if (column.filter_ === undefined)
      return null;
    let filter = column.filter_;
    let colName = column.dataField;
    let filterName = this.getFilterName(colName);
    if (filter.type === undefined)
      return null;
    let filterType = filter.type;
    if (ColumnFormatters[filterType] === undefined)
      return null;
    if (filter.searchable && filterType !== 'text')
      throw new Error("Searchable filter must be used only for text filters!");
    let onChangeHandler = value => {
      this.props.setFilterValue(this.props.objectName, filterName, value);
    };
    const formatterParams = this.createFormatterParams(
      filter, onChangeHandler, this.props.filterValues[this.props.objectName][filterName]
    );

    const formatter = (column, colIndex, { sortElement, filterElement }) => {
      return ColumnFormatters[filterType](
        column, colIndex, { sortElement, filterElement }, formatterParams);
    };
    return formatter;
  }

  getFilteredData() {
    let fdata = this.props.data;
    this.filterFuncs.forEach(filterFunc => {
      fdata = filterFunc(fdata);
    });
    return fdata;
  }

  clearFilters = () => {
    this.props.clearFilters(this.props.objectName);
  };

  clearSelection = () => {
    this.props.clearSelection(this.props.objectName);
  };

  defaultSortFunc = (a, b, order) => {
    if (a < b) return (order === 'asc') ? -1 : 1;
    if (a > b) return (order === 'asc') ? 1 : -1;
    return 0;
  }

  render() {
    let columns = this.props.columns.map(column => {
      let formatter = this.createFormatter(column);
      if (formatter !== null)
        column.headerFormatter = formatter;
      const columnWithExtraProps = {
        ...column,
        headerAttrs: { 'data-tooltip-type': column.filter_.type },
        onSort: (field, order) => {
          this.props.setOrderDirection(this.props.objectName, field, order);
        },
      };
      if (columnWithExtraProps.sort === undefined || !columnWithExtraProps.sort)
        return columnWithExtraProps;
      let prevSortFunc = columnWithExtraProps.sortFunc === undefined ?
        this.defaultSortFunc : columnWithExtraProps.sortFunc;
      columnWithExtraProps.sortFunc = (a, b, order, colname, arow, brow) => {
        let prevSortRes = prevSortFunc(a, b, order, colname, arow, brow);
        if (prevSortRes !== 0) return prevSortRes;
        if (arow.id === undefined || brow.id === undefined) return 0;
        return this.defaultSortFunc(arow.id, brow.id, order);
      }

      if (columnWithExtraProps.filter_.searchable) {
        columnWithExtraProps.events = {
          onClick: (e, column, columnIndex, row) => {
            if (e.altKey) {
              let colName = column.dataField;
              let filterName = this.getFilterName(colName);
              // Разбиение вложенного объекта для корректного обращения
              let resolvedPath = colName.split('.').reduce((prev, curr) => prev && prev[curr], row);
              this.props.setFilterValue(this.props.objectName, filterName, resolvedPath);
            }
          },
        }
      }

      return columnWithExtraProps;
    });

    let data = this.getFilteredData();

    let selectRow = {};
    if (this.isSelectable) {
      this.props.selected.forEach(id => {
        if (data.find(lic => lic.id === id) === undefined) {
          this.props.onSelect(id, false);
        }
      });

      let selectRowVal = {
        mode: 'checkbox',
        clickToSelect: false,
        selected: this.props.selected,
        onSelect: (row, isSelect) => this.props.onSelect(row.id, isSelect),
        onSelectAll: (isSelect, rows) => this.props.onSelectAll(rows.map(row => row.id), isSelect),
        selectionHeaderRenderer: ({ indeterminate, ...rest }) => (
          <input
            type="checkbox"
            ref={(input) => {
              if (input) {
                input.checked = this.props.selected.length > 0;
                input.indeterminate = this.props.selected.length > 0 && this.props.selected.length !== data.length;
              }
            }}
            {...rest}
          />
        )
      };
      selectRow = { selectRow: selectRowVal };
    }

    const paginationOptions = {
      ...this.props.paginationTables[this.props.objectName],
      onSizePerPageChange: (sizePerPage, page) => {
        const { objectName } = this.props;
        this.props.setPagination(objectName, page, sizePerPage);
      },
      onPageChange: (page, sizePerPage) => {
        const { objectName } = this.props;
        this.props.setPagination(objectName, page, sizePerPage);
      },
      ...this.props.paginationOptions,
      sizePerPageList: [{
        text: '10',
        value: 10
      }, {
        text: '25',
        value: 25
      }, {
        text: '30',
        value: 30
      }, {
        text: '50',
        value: 50
      }, {
        text: '100',
        value: 100
      }]
    };

    const { dataField, order } = this.props.sortTables[this.props.objectName];

    const sorted = dataField && order ? [{
      dataField: this.props.sortTables[this.props.objectName].dataField,
      order: this.props.sortTables[this.props.objectName].order,
    }] : this.props.defaultSorted;

    const isAnyItemSelected = this.props.selected && this.props.selected.length;

    const filters = this.props.filterValues[this.props.objectName];
    const isAnyFilterApplied = Object.keys(filters).length !== 0;

    return (
      <div>
        <FilterTableHeader 
          total={data.length} 
          clearFilters={this.clearFilters} 
          clearSelection={this.clearSelection} 
          isSelectable={this.isSelectable} 
          isAnyItemSelected={isAnyItemSelected} 
          isAnyFilterApplied={isAnyFilterApplied}
        />
        <BootstrapTable
          {...this.props}
          // striped
          defaultSorted={sorted}
          keyField="id"
          data={data}
          columns={columns}
          pagination={paginationFactory(paginationOptions)}
          classes="autoWithColumnTable"
          rowEvents={this.props.rowEvents}
          {...selectRow}
        />
      </div>
    );
  }
}

const actionCreators = {
  setFilterValue: filterValuesActions.setFilterValue,
  clearFilters: (objectName) => filterValuesActions.clearFilters(objectName),

  setPagination: paginationTablesActions.setPagination,
  setOrderDirection: sortTablesActions.setSortDirection,

  clearSelection: selectedItemsActions.clearSelection,
};

const mapStateToProps = (state) => ({
  filterValues: state.userConfigs.filterValues,
  paginationTables: state.userConfigs.paginationTables,
  sortTables: state.userConfigs.sortTables,
});

export default connect(mapStateToProps, actionCreators)(FilterTable);



// WEBPACK FOOTER //
// ./src/components/filterTable.js